module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_arrow_left.b40a7ce4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_arrow_left.svg
// module id = 982
// module chunks = 0